import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { ref, onMounted, nextTick } from "vue";
import { ElIcon } from "element-plus";
import PointsMallOld from "@/components/PointsMallOld/PointsMallOld.vue";
import { ArrowRightBold, MoreFilled } from "@element-plus/icons-vue";
import { getList, GeneratingOrder, getRole, pcWechatType, getPoints, wechatAuthorization, gameDetail, updateUser, getPayForOtherLogin } from "@/api/api";
import { showToast, Popup, showDialog } from "vant";
import "vant/lib/index.css";
import bus from "@/lib/bus";
import { useRouter } from "vue-router";
import QRCode from "qrcodejs2";
import { buriedLogger } from "@/utils/utils";
export default {
  components: {
    ElIcon,
    ArrowRightBold,
    MoreFilled,
    [Popup.name]: Popup,
    [showDialog.name]: showDialog,
    PointsMallOld
  },
  setup(props) {
    // 选择的区服
    const role_id = ref("");
    const roleIndex = ref(0); //选择角色的序号
    const choiceGameDistName = e => {
      roleIndex.value = e.target.selectedIndex - 1;
      role_id.value = areaList.value[roleIndex.value].role_id;
      roleName.value = areaList.value[roleIndex.value].nickname;
    };
    const payType = ref("alipay"); //支付类型
    // 生成微信支付二维码
    const showWechatCode = ref(false);
    const wechatTradeNo = ref("");
    const qrcode = () => {
      const dom = document.getElementById("qrcode");
      const url = document.location.toString();
      const arrUrl = url.split("//");
      var start = arrUrl[1].split("/");
      /* eslint-disable */
      new QRCode("qrcode", {
        width: dom.clientWidth,
        height: dom.clientHeight,
        text: `${arrUrl[0]}//${start[0]}/gamepaypage?cashier=${wechatTradeNo.value}`,
        colorDark: "#5258A9",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    };
    // 判断是否为移动端
    const payMethods = ref("wap"); //支付类型:web电脑，app应用端，wap手机h5支付, mp为微信jssdk支付，微信PC为scan
    const isMobile = () => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? payMethods.value = "wap" : payMethods.value = "web";
    };
    const showAliPay = ref(false);
    const isWeiXin = () => {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        showAliPay.value = false;
        payType.value = "wechat";
        getOpenId();
        if (ua.match(/windowswechat/i) == "windowswechat") {
          payMethods.value = "scan";
        } else {
          payMethods.value = "mp";
        }
      } else {
        showAliPay.value = true;
        return isMobile();
      }
    };
    const loginType = ref(1);
    //累计充值底部进度条计算距离
    const longW = ref(0);
    const hLongW = ref(0);
    const iconW = ref(0);
    const dottedLeft = ref(0);
    const dottedW = ref(0);
    const progressWidth = ref(0);
    const rechargeBodyWidth = ref(0);
    const leftW = e => {
      let type = 0;
      if (e < 0) {
        if (rechargeCategoryList.value[0].is_rewards == 1) {
          type = rechargeCategoryList.value.length;
        } else type = 0;
      } else type = e;
      if (payMethods.value == "wap") {
        rechargeBodyWidth.value = document.getElementById("recharge-block-container-sec").getBoundingClientRect().width;
        if (80 * rechargeCategoryList.value.length < rechargeBodyWidth.value) {
          progressWidth.value = rechargeBodyWidth.value;
        } else progressWidth.value = 80 * rechargeCategoryList.value.length;
        setTimeout(() => {
          let hMaxW = document.getElementById("hrecharge-icon-list").getBoundingClientRect().width;
          let beginIconsec = document.getElementById("h-begin-icon").getBoundingClientRect().right;
          if (type == rechargeCategoryList.value.length) {
            hLongW.value = hMaxW;
            iconW.value = document.getElementById(`hrecharge-icon-${type - 1}`).getBoundingClientRect().right - beginIconsec - 14;
            return;
          }
          let endIconsec = document.getElementById(`hrecharge-icon-${type}`).getBoundingClientRect().right;
          hLongW.value = endIconsec - beginIconsec - 12;
          iconW.value = endIconsec - beginIconsec - 14;
          if (type == 0) {
            dottedLeft.value = 0;
            dottedW.value = endIconsec - beginIconsec - 12;
          } else if (type == rechargeCategoryList.value.length) {
            dottedW.value = 0;
            dottedLeft.value = 0;
          } else {
            let hEndDotted = document.getElementById(`hrecharge-icon-${type - 1}`).getBoundingClientRect().right;
            dottedW.value = endIconsec - hEndDotted - 8;
            dottedLeft.value = hEndDotted - beginIconsec;
          }
        }, 500);
      } else {
        if (155 * rechargeCategoryList.value.length < 712) {
          progressWidth.value = 712;
        } else progressWidth.value = 155 * rechargeCategoryList.value.length;
        setTimeout(() => {
          let maxW = document.getElementById("recharge-icon-list").getBoundingClientRect().width;
          let beginIcon = document.getElementById("begin-icon").getBoundingClientRect().right;
          if (type == rechargeCategoryList.value.length) {
            longW.value = maxW;
            iconW.value = document.getElementById(`recharge-icon-${type - 1}`).getBoundingClientRect().right - beginIcon - 22;
            return;
          }
          let endIcon = document.getElementById(`recharge-icon-${type}`).getBoundingClientRect().right;
          longW.value = endIcon - beginIcon - 6;
          iconW.value = endIcon - beginIcon - 22;
          if (type == 0) {
            dottedLeft.value = 0;
            dottedW.value = endIcon - beginIcon;
          } else if (type == rechargeCategoryList.value.length) {
            dottedW.value = 0;
            dottedLeft.value = 0;
          } else {
            let endDotted = document.getElementById(`recharge-icon-${type - 1}`).getBoundingClientRect().right;
            dottedW.value = endIcon - endDotted - 16;
            dottedLeft.value = endDotted - beginIcon;
          }
        }, 500);
      }
    };
    const logger = ref("");
    onMounted(() => {
      const bl = buriedLogger("qc-recharge-platform", "游戏支付详情页面");
      gameId.value = route.currentRoute.value.query.gameId;
      logger.value = bl;
      logger.value.sum(`当前的游戏ID${gameId.value}`);
      if (localStorage.getItem("token") && !route.currentRoute.value.query.token) {
        loginType.value = 2;
        mobile.value = localStorage.getItem("mobile");
        getPointsDetail();
        if (!roleName.value) {
          showGameRole();
        }
        interPage();
      } else if (route.currentRoute.value.query.token) {
        LoginByNoSignIn();
      } else {
        interPage();
      }
      isWeiXin();
    });
    //免密登录
    const LoginByNoSignIn = () => {
      getPayForOtherLogin({
        token: route.currentRoute.value.query.token
      }).then(res => {
        if (res.code == 200) {
          localStorage.setItem("token", res.data.access_token);
          localStorage.setItem("mobile", res.data.mobile);
          bus.$emit("sendToken", res.data.access_token);
          loginType.value = 2;
          mobile.value = res.data.mobile;
          if (!res.data.role_id || !res.data.server_id) {
            return;
          }
          if (res.data.game_id != gameId.value) {
            return;
          }
          role_id.value = res.data.role_id;
          roleName.value = res.data.role_name;
          chooseGameList.value = res.data;
          getPointsDetail();
        } else showToast(res.message);
        interPage();
      });
    };
    // 微信授权
    const getOpenId = () => {
      wechatAuthorization().then(res => {
        if (res.data.open_id) {
          localStorage.setItem("openId", res.data.open_id);
          return;
        }
      });
    };
    // 获取官方充值信息
    const list = ref([]); //代金券列表
    const otherList = ref([]); //其他商品列表
    const choiceItem = ref({});
    const route = useRouter();
    const gameId = ref(0); //当前的游戏ID
    const getListInfo = () => {
      getList().then(res => {
        let gameList = res.data.list;
        if (gameId.value) {
          gameList.forEach(item => {
            if (item.game_id == gameId.value) {
              list.value = item;
            }
          });
        } else {
          list.value = res.data.list[0];
          gameId.value = res.data.list[0].game_id;
        }
        choiceItem.value = list.value.product[0];
      });
    };
    // 获取游戏充值商品详情
    const gameListTop = ref([]);
    const nowGameListType = ref(0);
    const amountPaid = ref(0); //累计充值已充值金额
    const distanceAmount = ref(0); //距离下一个奖励的金额
    const rechargeCategoryList = ref([]); //累计充值标题
    const rechargeTitle = ref("");
    const rechargePhase = ref(0); //累计充值阶段
    const getListDetails = () => {
      gameDetail(gameId.value, role_id.value || "").then(res => {
        if (res.data.list && res.data.list.length > 0) {
          gameListTop.value = res.data.list;
          gameListTop.value.forEach(item => {
            if (item.game_id == gameId.value) {
              list.value = item;
              amountPaid.value = item.user_bonus_price || 0;
              rechargeCategoryList.value = item.bonus_list || [];

              // 接口传过来的累计充值有数据，进行计算
              if (rechargeCategoryList.value.length > 0) {
                rechargeTitle.value = item.bonus_detail;
                let index = rechargeCategoryList.value.findIndex(item => item.is_rewards != 1);
                if (index < 0) {
                  if (rechargeCategoryList.value[0].is_rewards == 1) {
                    rechargePhase.value = rechargeCategoryList.value.length - 1;
                  } else rechargePhase.value == 0;
                } else rechargePhase.value = index;
                distanceAmount.value = rechargeCategoryList.value[rechargePhase.value].price - amountPaid.value > 0 ? (rechargeCategoryList.value[rechargePhase.value].price - amountPaid.value).toFixed(2) : 0;
                hLongW.value = 0;
                longW.value = 0;
                dottedW.value = 0;
                dottedLeft.value = 0;
                nextTick(() => {
                  leftW(index);
                });
              }
            }
          });
          if (choiceItem.value.type == "代钞") {
            choiceItem.value = list.value.product[choiceIndex.value];
            return;
          }
          if (choiceItem.value.name) {
            return;
          }
          choiceItem.value = list.value.product[choiceIndex.value];
        }
      });
    };
    const randomRange = (min, max) => {
      // min最小值，max最大值
      return Math.floor(Math.random() * (max - min)) + min;
    };
    // 调取支付
    const tradeNum = ref(""); //PC微信轮询订单
    const wechatPayTest = ref("");
    const showRoleFromPayBtn = ref(false);
    const showWechatAlipay = ref(false);
    const setPay = () => {
      if (!localStorage.getItem("token")) {
        return bus.$emit("click"); //未登录调取登录接口
      }
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger" && payType.value == "alipay") {
        return showWechatAlipay.value = true;
      }
      if (list.value.status == 2) {
        return showDialog({
          title: "温馨提示",
          message: "游戏维护期间，暂时无法为您充值，给您造成的不便敬请谅解。",
          confirmButtonColor: "#8383FF",
          confirmButtonText: "好的"
        }).then(() => {
          // on close
        });
      }
      if (!choiceItem.value.id) {
        return showToast("请选择商品类目");
      }
      if (!chooseGameList.value.role_id) {
        showRoleFromPayBtn.value = true;
        getRoleList();
        return;
      }
      showH5Details.value = false;
      if (payMethods.value == "web" && payType.value == "wechat") {
        payMethods.value = "scan";
      }
      if (payMethods.value == "scan" && payType.value != "wechat") {
        payMethods.value = "web";
      }
      const url = document.location.toString();
      const arrUrl = url.split("//");
      const start = arrUrl[1].split("/");
      let returnUrl = `${arrUrl[0]}//${start[0]}/gamepaypage?type=2`;
      if (payMethods.value == "wap" && payType.value == "wechat") {
        returnUrl = `${arrUrl[0]}//${start[0]}/gamepaypage?type=4`;
      }
      // pay.qingcigame.com 正式线上地址
      let prams = {
        pay_type: payType.value,
        //alipay支付宝   wechat微信   pay_behalf 代付
        game_id: gameId.value,
        pay_method: payMethods.value,
        sku_id: channelType.value == 2 ? choiceItem.value.sku_id : choiceItem.value.id,
        sku_desc: choiceItem.value.name,
        price: choiceItem.value.price,
        currency: "CNY",
        os: sysTem.value,
        return_url: returnUrl,
        server_id: chooseGameList.value.dist_id || chooseGameList.value.server_id,
        role_id: chooseGameList.value.role_id,
        zone: chooseGameList.value.zone || chooseGameList.value.server_id,
        dist_name: chooseGameList.value.dist_name || chooseGameList.value.server_name,
        roles_name: chooseGameList.value.nickname || chooseGameList.value.role_name,
        prop_id: channelType.value == 2 ? choiceItem.value.id : "",
        channel: channelType.value
      };
      GeneratingOrder(prams).then(res => {
        if (res.code == 200) {
          if (payType.value == "alipay") {
            document.getElementById("aliPayBtn").innerHTML = res.data.order;
            document.forms["alipaysubmit"].submit();
          } else if (payType.value == "wechat") {
            if (payMethods.value == "scan") {
              //pc微信支付
              wechatTradeNo.value = res.data.cashier;
              tradeNum.value = res.data.trade_no;
              showWechatCode.value = true;
              nextTick(() => {
                qrcode();
                setTimeout(() => {
                  pcWecht();
                }, 2000);
              });
            }
            if (payMethods.value == "wap") {
              // 移动端非微信浏览器调用微信支付
              window.location.href = res.data.redirect_uri;
            }
            if (payMethods.value == "mp") {
              // 移动端微信浏览器内调用微信支付
              bus.$emit("closePayHeader");
              route.push({
                path: `./gamepaypage`,
                query: {
                  cashier: res.data.cashier
                }
              });
            }
          } else {
            bus.$emit("closePayHeader");
            // 代付
            route.push({
              path: `./payforanother`,
              query: {
                orderid: res.data.order_no,
                gameid: gameId.value,
                ordertype: 2
              }
            });
          }
        } else if (res.code == 401) {
          showToast(res.message);
          bus.$emit("click"); //未登录调取登录接口
          bus.$emit("loginOut");
        } else {
          if (res.data.is_verified) {
            realNamePopup.value = true;
            return;
          }
          showToast(res.message);
        }
      });
    };
    //监听微信支付二维码弹窗关闭
    const qrcodes = ref(null);
    const closeQrcode = () => {
      qrcodes.value.innerHTML = "";
      clearTimeout(wechatPayTest.value);
    };
    // 区服选择弹窗
    const show = ref(false);
    const showGameRole = () => {
      if (!localStorage.getItem("token")) {
        bus.$emit("click");
        bus.$emit("loginOut"); //未登录调取登录接口
        return;
      }
      getRoleList();
    };
    // 选取购买的物品
    const choiceIndex = ref(0);
    const channelType = ref(1); //渠道，1代金券2为其他道具
    const choicePay = (e, index, type) => {
      if (e.game_stock == e.quantity && e.quantity >= 0) {
        return showToast("当前商品售罄");
      }
      choiceItem.value = e;
      choiceIndex.value = index;
      channelType.value = type;
      if (payMethods.value == "wap" || payMethods.value == "mp") {
        showH5Pay();
      }
    };
    // 获取当前页面信息
    const interPage = () => {
      bus.$emit("showPayHeader");
      if (!gameId.value) {
        route.push({
          path: `./home`
        });
        return;
      }
      getListDetails();
    };
    // 监听登录
    bus.$on("login", () => {
      if (props.uiType != "close") return;
      channelType.value = 1;
      choiceItem.value = "";
      choiceIndex.value = 0;
      getPointsDetail();
      getListDetails();
      if (gameId.value) {
        showGameRole();
      }
    });
    // 切换大区
    const changeGame = e => {
      chooseGameList.value = {};
      channelType.value = 1;
      gameId.value = e.game_id;
      roleList.value = {};
      role_id.value = "";
      bus.$emit("roleInfo", {});
      getListDetails();
    };
    const sysTem = ref("android"); // 当前选择的系统
    // 选择系统
    const chooseSystem = e => {
      sysTem.value = e;
      getRoleList();
    };
    // 获取账号的游戏角色
    const areaList = ref([]); //区服列表
    const chooseArea = ref("请选择区服"); //选择的区服
    const roleName = ref(""); //选区对应的角色
    const getRoleList = () => {
      latelyPayRole.value = {};
      roleName.value = "";
      chooseArea.value = "请选择区服";
      getRole({
        game_id: gameId.value,
        os: sysTem.value
      }).then(res => {
        if (res.code == 200) {
          areaList.value = res.data;
          areaList.value.forEach(item => {
            if (item.is_last_pay == 1) {
              latelyPayRole.value = item;
              // chooseGameList.value = item;
              // roleName.value = item.nickname;
              // role_id.value = item.role_id;
              // chooseArea.value = `${item.dist_name}-${item.nickname}`;
            }
          });
          show.value = true;
        } else if (res.code == 401) {
          localStorage.removeItem("token");
          bus.$emit("loginOut");
          bus.$emit("click"); //未登录调取登录接口
          return;
        } else {
          // js正则删除换行符
          const regex = /\\n/g;
          const result = res.message.replace(regex, "");
          showToast(result);
        }
      });
    };
    // 切换支付方式
    const changePay = e => {
      payType.value = e;
    };
    // 确定选择
    const chooseGameList = ref({}); //选择的角色的信息
    const roleList = ref({}); //选择的角色（传递给积分商城页用）
    const confirmChoose = () => {
      if (!roleName.value) {
        return showToast("请选择区服信息");
      }
      chooseGameList.value = areaList.value[roleIndex.value];
      roleList.value = chooseGameList.value;
      roleList.value.sysTem = sysTem.value;
      bus.$emit("roleInfo", roleList.value);
      if (gameId.value) {
        localStorage.setItem("gameId", gameId.value);
      }
      show.value = false;
      if (showRoleFromPayBtn.value) {
        setPay();
      }
      if (showH5Details.value) {
        showH5PayPopup.value = true;
      }
      getListDetails();
    };
    // 微信订单状态轮询查询
    const pcWecht = () => {
      pcWechatType({
        trade_no: tradeNum.value,
        game_id: gameId.value
      }).then(res => {
        if (res.code == 404) {
          wechatPayTest.value = setTimeout(() => {
            pcWecht();
          }, 3000);
        } else if (res.code == 200) {
          showWechatCode.value = false;
          setTimeout(() => {
            route.push({
              path: `./orderpage`
            });
          }, 2000);
        }
      });
    };
    // 用户服务协议
    const goRuler = () => {
      window.open(list.value.service_url, "_blank");
    };
    //注销监听
    bus.$on("clear", () => {
      chooseGameList.value = {};
      mobile.value = "";
      loginType.value = 1;
      pointsNum.value = 0;
      role_id.value = "";
    });
    // h5支付弹窗
    const showH5PayPopup = ref(false);
    const showH5Details = ref(false);
    const showH5Pay = () => {
      if (!localStorage.getItem("token")) {
        bus.$emit("click");
        bus.$emit("loginOut"); //未登录调取登录接口
        return;
      }
      if (!chooseGameList.value.role_id) {
        showH5Details.value = true;
        getRoleList();
        return;
      }
      showH5PayPopup.value = true;
    };
    // 调起登录弹窗
    const mobile = ref("");
    const loginBtn = () => {
      return bus.$emit("click"); //未登录调取登录接口
    };
    // 监听登录
    bus.$on("login", () => {
      loginType.value = 2;
      mobile.value = localStorage.getItem("mobile");
    });
    // 注销点击
    const loginOut = () => {
      loginType.value = 1;
      mobile.value = "";
      choiceIndex.value = 0;
      role_id.value = "";
      pointsNum.value = 0;
      getListDetails();
      bus.$emit("loginOut");
    };
    // 关闭区服选择弹窗
    const closeRolePopup = () => {
      showRoleFromPayBtn.value = false;
      showH5Details.value = false;
    };
    const realNamePopup = ref(false); //实名认证弹窗
    const cardIdNum = ref(""); //身份证
    const userName = ref(""); //姓名
    // 身份证校验
    const validateIDCard = idCard => {
      // Regular expression to match the ID card pattern
      var pattern = /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2]\d|3[0-1])\d{3}[\dX]$/;
      // Check if the ID card matches the pattern
      if (pattern.test(idCard)) {
        return true;
      } else {
        return false;
      }
    };
    const updataUserBtn = () => {
      if (!cardIdNum.value || !userName.value) return showToast("请填写完整信息");
      if (!validateIDCard(cardIdNum.value)) {
        return showToast("请输入正确的身份证格式");
      }
      updateUser({
        real_name: userName.value,
        card_no: cardIdNum.value
      }).then(res => {
        if (res.code == 200) {
          showToast("实名认证成功！");
          realNamePopup.value = false;
        } else {
          showToast(res.message);
        }
      });
    };
    const getPointsDetail = () => {
      getPoints().then(res => {
        if (res.code == 200) {
          pointsNum.value = res.data.points;
          localStorage.setItem("pointsNum", pointsNum.value);
        }
      });
    };
    const showCashCoupon = ref(true); //是否为代金券页面
    const pointsNum = ref(0); //当前积分
    bus.$on("points", e => {
      pointsNum.value = e;
    });
    // 兑换记录跳转
    const goExchangePage = () => {
      if (!mobile.value) return bus.$emit("click"); //未登录调取登录接口
      route.push({
        path: `./exchangerecord`
      });
    };
    // 积分记录跳转
    const goPointsDetail = () => {
      if (!mobile.value) return bus.$emit("click"); //未登录调取登录接口
      route.push({
        path: `./integraldetail`
      });
    };
    // 前往积分商城
    const goJfMallPage = () => {
      showCashCoupon.value = false;
      nextTick(() => {
        if (roleList.value.sysTem) {
          bus.$emit("roleInfo", roleList.value);
        }
      });
    };
    const latelyPayRole = ref("");
    return {
      roleList,
      goExchangePage,
      goPointsDetail,
      pointsNum,
      showCashCoupon,
      roleIndex,
      validateIDCard,
      loginOut,
      loginType,
      mobile,
      loginBtn,
      getListDetails,
      showH5Pay,
      showH5PayPopup,
      choiceGameDistName,
      wechatPayTest,
      role_id,
      tradeNum,
      goRuler,
      getOpenId,
      wechatTradeNo,
      pcWecht,
      qrcodes,
      closeQrcode,
      showWechatCode,
      qrcode,
      payMethods,
      chooseGameList,
      confirmChoose,
      changePay,
      payType,
      roleName,
      areaList,
      chooseArea,
      gameId,
      getRoleList,
      chooseSystem,
      sysTem,
      show,
      showGameRole,
      interPage,
      getListInfo,
      setPay,
      choiceItem,
      list,
      choicePay,
      randomRange,
      isMobile,
      isWeiXin,
      showAliPay,
      showRoleFromPayBtn,
      showH5Details,
      closeRolePopup,
      gameListTop,
      nowGameListType,
      changeGame,
      choiceIndex,
      showWechatAlipay,
      realNamePopup,
      updataUserBtn,
      userName,
      cardIdNum,
      otherList,
      channelType,
      latelyPayRole,
      LoginByNoSignIn,
      distanceAmount,
      longW,
      hLongW,
      iconW,
      amountPaid,
      rechargeCategoryList,
      rechargeTitle,
      rechargePhase,
      goJfMallPage,
      dottedLeft,
      dottedW,
      logger,
      goJfMallPage,
      progressWidth,
      rechargeBodyWidth
    };
  }
};